/* ═══════════════════════════════════════════════════════════════════════════
   TAIRUS · COMPORTAMIENTO COMPARTIDO DE LA LANDING
   assets/tairus-sistema.js

   Tres cosas, y ninguna es decorativa:

   1. APARICION AL ENTRAR  — los bloques suben 14 px al asomarse.
   2. VIDEO SOLO CUANDO SE VE — un mp4 que arranca al cargar la pagina se come
      los datos de alguien que quiza no baje nunca hasta el. Se reproduce al
      entrar en pantalla y se pausa al salir.
   3. BAJAR AL FORMULARIO  — cualquier boton con [data-tls-comprar] lleva al
      formulario COD de Releasit, que vive dentro de #form-cod-embed.

   REGLA DE ORO: la pagina tiene que verse SIN este archivo. Por eso la clase
   .tls-vivo se pone desde aqui: si el script no corre, el CSS no esconde nada.
   Al reves seria una trampa — un fallo del JS dejaria una pantalla en blanco.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Guardia de una sola vez: varias secciones cargan este mismo archivo y el
  // navegador lo ejecuta una vez por URL, pero en el editor de temas Shopify
  // re-inyecta secciones sueltas y puede volver a correrlo.
  if (window.__tlsSistema) return;
  window.__tlsSistema = true;

  var quieto = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── 1. Aparicion ────────────────────────────────────────────────────────
  // Sin IntersectionObserver (Android viejo) no se anima y se ve todo: la
  // ausencia de animacion no es un fallo, la ausencia de contenido si.
  if ('IntersectionObserver' in window && !quieto) {
    document.documentElement.classList.add('tls-vivo');

    var ojo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('tls-dentro');
        ojo.unobserve(e.target);   // una vez dentro, ya no vuelve a salir
      });
    }, {
      // 12% de margen inferior negativo: el bloque empieza a entrar cuando ya
      // esta bien dentro de la pantalla, no rozando el borde. Rozando parece
      // que la pagina va con retraso.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.01
    });

    var observar = function (raiz) {
      (raiz || document).querySelectorAll('.tls-entra:not(.tls-dentro)')
        .forEach(function (n) { ojo.observe(n); });
    };
    observar();
    // El editor de temas re-renderiza una seccion sin recargar la pagina.
    document.addEventListener('shopify:section:load', function (e) {
      observar(e.target);
    });
  }

  // ── 2. Video solo cuando se ve ──────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var ojoVideo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          // play() devuelve una promesa que el navegador rechaza si bloquea la
          // reproduccion automatica. Sin el catch queda un error rojo en
          // consola de algo que no es un fallo nuestro.
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    var observarVideos = function (raiz) {
      (raiz || document).querySelectorAll('video[data-tls-video]')
        .forEach(function (v) { ojoVideo.observe(v); });
    };
    observarVideos();
    document.addEventListener('shopify:section:load', function (e) {
      observarVideos(e.target);
    });
  }

  // ── 3. Abrir el formulario de compra ────────────────────────────────────
  //
  // Quien cobra es Releasit. Su boton por defecto (`._rsi-buy-now-button`, un
  // div naranja que ademas se SACUDE — la clase se llama `-shaker`) esta
  // escondido por CSS: no tiene nada que ver con esta landing. El que se ve es
  // el nuestro, y al pulsarlo hace clic en el suyo.
  //
  // ES UN CLIC, NO UN SCROLL. Comprobado en la tienda: el boton de Releasit
  // abre un MODAL (`#_rsi-cod-form-modal`, position fixed) que tapa la
  // pantalla entera. Al ser modal da igual donde este el embed, asi que no
  // hace falta repetirlo por la pagina ni llevar a nadie hasta el: se abre
  // donde este la persona. Antes esto bajaba la pagina hasta el formulario, lo
  // cual con un modal es un viaje para nada.
  //
  // El suyo se busca EN EL MOMENTO DEL CLIC: Releasit lo pinta con JavaScript
  // y al cargar la pagina todavia no existe.
  function botonDeReleasit() {
    // Releasit pinta DOS: el del formulario incrustado y uno flotante. El
    // flotante va con `display:none` en esta plantilla (tenemos barra propia),
    // y sobre un nodo sin caja hay librerias que no reaccionan al clic. Se
    // elige explicitamente el que NO es flotante en vez de fiarse del orden
    // del documento, que puede cambiar cuando a Releasit le de por cambiarlo.
    var todos = document.querySelectorAll('._rsi-buy-now-button');
    for (var i = 0; i < todos.length; i++) {
      if (!todos[i].classList.contains('_rsi-buy-now-button-floating')) {
        return todos[i];
      }
    }
    return todos[0] || null;
  }

  function formularioVisible() {
    return document.querySelector('#form-cod-embed, [id*="__form_cod"], '
                                + 'form[action*="/cart/add"]');
  }

  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest && ev.target.closest('[data-tls-comprar]');
    if (!boton) return;

    // La cantidad de los combos se pasa por el mismo puente que ya usa el tema
    // para sus paquetes. Se llama ANTES de abrir porque esa funcion reintenta
    // sola hasta que el campo existe.
    var cant = parseInt(boton.getAttribute('data-cantidad') || '0', 10);
    if (cant > 1 && typeof window.__escalaTrySetQty === 'function') {
      window.__escalaTrySetQty(cant);
    }

    var suyo = botonDeReleasit();
    if (suyo) {
      ev.preventDefault();
      suyo.click();
      return;
    }

    // Sin Releasit (no cargo, o la pagina no lo lleva) se cae al formulario
    // normal de la ficha. Peor experiencia, pero se puede comprar — que es lo
    // que no puede fallar.
    var destino = formularioVisible();
    if (!destino) return;      // sin nada a donde ir, el clic sigue su camino
    ev.preventDefault();
    destino.scrollIntoView({
      behavior: quieto ? 'auto' : 'smooth',
      block: 'center'
    });
  });
})();
